import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import config from "../config";

const baseUrl = config.baseURL;

const getToken = () => {
  const token = localStorage.getItem("token");
  if (!token) {
    toast.error("No authorization token found!");
    throw new Error("No authorization token found!");
  }
  return token;
};

export const fetchDataFromAPI = async (endpoint, params = {}) => {
  const token = localStorage.getItem("token");
  const url = `${baseUrl}${endpoint}?${new URLSearchParams(params)}`;
  const response = await fetch(url, {
    headers: { Authorization: `Bearer ${token}` },
    timeout: 120000,
  });
  console.log("response 1", response);

  if (!response.ok) {
    const errorMessage = `Error fetching data: ${response.statusText}`;
    toast.error(errorMessage); // Show error toast
    // throw new Error(errorMessage);
  }
  const data = await response.json();
  //   toast.success("Data fetched successfully!"); // Show success toast
  return data;
};
export const fetchAllPagesData = async (
  endpoint,
  { filters = {}, sortField = "", sortOrder = "", limit = 100 } = {}
) => {
  try {
    let allData = [];
    let page = 1;
    let hasMore = true;

    while (hasMore) {
      const paramsObj = {
        page,
        limit,
        ...filters,
        includeDeleted: "false",
      };

      if (sortField) paramsObj.sortField = sortField;
      if (sortOrder) paramsObj.sortOrder = sortOrder;

      // ✅ Fetch paginated data
      const { data, pagination } = await fetchDataFromAPI(endpoint, paramsObj);

      if (!data || data.length === 0) {
        hasMore = false;
      } else {
        allData = [...allData, ...data];
        hasMore = page < (pagination?.totalPages || 1);
        page++;
      }
    }

    console.log(`✅ All data fetched from ${endpoint}:`, allData.length);
    return allData;
  } catch (err) {
    console.error(`❌ Error fetching all data from ${endpoint}:`, err.message);
    toast.error("Failed to fetch all data");
    return [];
  }
};
export const saveData = async (endpoint, data, methodData) => {
  const token = localStorage.getItem("token");
  try {
    const response = await fetch(`${baseUrl}${endpoint}`, {
      method: methodData,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });

    console.log("response2", response);

    if (!response.ok) {
      const errorMessage = `Error saving data: ${response.statusText}`;
      toast.error(errorMessage);
      return null;
    } else {
      const responseData = await response.json();
      toast.success("Data saved successfully!");
      return responseData;
    }
  } catch (err) {
    console.error("❌ Network or CORS error:", err);
    toast.error("Network error: Could not reach server");
    return null;
  }
};

export const deleteData = async (endpoint) => {
  const token = localStorage.getItem("token");
  const response = await fetch(`${baseUrl}${endpoint}`, {
    method: "DELETE",
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) {
    const errorMessage = `Error deleting data: ${response.statusText}`;
    toast.error(errorMessage); // Show error toast
    throw new Error(errorMessage);
  }

  toast.success("Data deleted successfully!"); // Show success toast
  return response.json();
};
